<template>
  <q-scroll-area style="height: calc(100vh - 50px) !important">
    <q-page fluid>
      <div class="row full-width">
        <div class="col-12">
          <q-card class="full-width">
            <q-card-section>
              <div class="row items-center">
                <div style="display: inline-block" class="text-h6">
                  Table of contents
                </div>

                <q-space />
                <q-toggle
                  v-if="apiUrl != 'https://api.Waves App.com'"
                  v-model="apiUrlSelection"
                  :label="`${apiUrlSelection ? 'Dev Site' : 'Live Site'}`"
                ></q-toggle>
              </div>
            </q-card-section>

            <q-separator />

            <q-card-section>
              <q-tree
                :nodes="itemsAdmin"
                node-key="name"
                label-key="name"
                :selected.sync="selected"
                v-if="currentUserData.role == 'superAdmin'"
              >
              </q-tree>
              <q-tree
                :nodes="items"
                node-key="name"
                label-key="name"
                :selected.sync="selected"
                v-if="currentUserData.role != 'superAdmin'"
              >
              </q-tree>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-12 q-mt-md">
          <!-- Application Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Applications
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="applicationAbout" style="display: inline-block" class="text-h6">What is an Application?</div>
            <p>
              An Application is a White Labeled application that is running on the System. There is a Long process to get these set up, and can only be created by Super Admins.
              An example of an Application is Critter Pic
            </p>
            <div id="applicationCreation" style="display: inline-block" class="text-h6">Creating an Application</div>
            <p>
              To create an Application there are a few steps.
              <ol>
                <li>First you have to Create the Application using the "Applications" interface on Waves App Website</li>
                <li>For Now you will need to contact Simple Software to set up the rest, aswell as the domains. This is because Oauth (Google Signin),
                  Auth0(Credentials Manager), Amplify (Front end Hosting) and Route53 need to be set up with the Applications Domain.
                </li>
              </ol>
            </p>
            <div style="display: inline-block" class="text-h6" id="applicationManagement">Managing an Application</div>
            <p>
              To manage an application, you can do this through the Applications interface. If you wish to change the domain, you will need to contact Simple software.
            </p>
          </q-card-section>
        </q-card> -->
          <!-- Organizations Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Organizations
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="organizationAbout" style="display: inline-block" class="text-h6">What is an Organization?</div>
            <p>
              An Organization is an Entity that is a part of an Application. An example of an Organization is Boffa Miskell.
            </p>
            <div id="organizationCreation" style="display: inline-block" class="text-h6">Creating an Organization</div>
            <p>
              To create an Organization, use the Organizations interface. You will need a Name for the Organization, and an Application to assign the Organization to.
            </p>
            <div style="display: inline-block" class="text-h6" id="organizationnManagement">Managing an Organization</div>
            <p>
              To manage an Organization, you can do this through the Organizations interface. You will not be able to move an Organization to another Application, but you can change its name.
            </p>
          </q-card-section>
        </q-card> -->
          <!-- Ownership Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Ownerships
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="ownershipAbout" style="display: inline-block" class="text-h6">What is an Ownership?</div>
            <p>
              An Ownership is what assigns a Device to an Organization. This will allow the Organization to deploy its devices and have the events allowed to be attached to their Org.
            </p>
            <div id="ownershipCreation" style="display: inline-block" class="text-h6">Creating an Ownership</div>
            <p>
              To create an Ownership, use the Ownership interface. You will need to know the Organization and Device ID.
            </p>
            <div style="display: inline-block" class="text-h6" id="ownershipManagement">Ending an Ownership</div>
            <p>
              To End an Ownership, Double click on the ownership you wish to end, then select click the "End Ownership" button. (This will end a Deployment that is associated with that ownership)
            </p>
          </q-card-section>
        </q-card> -->
          <!-- Ownership Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Deployments
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="deploymentAbout" style="display: inline-block" class="text-h6">What is a Deployment?</div>
            <p>
              A Deployment is a period in time where All requests from a device will be associated with the Deployment.
              This is used to Groups events together, and allow you to assign users to a specific deployment.
              You can also assign a User to past deployments so they can view events from the past.
            </p>
            <div id="deploymentCreation" style="display: inline-block" class="text-h6">Creating an Deployment</div>
            <p>
              To create a Deployment, use the Deployment interface. You will need to know the organization the device is a part of, the device ID, and have a name for the deployment.
            </p>
            <div style="display: inline-block" class="text-h6" id="deploymentManagement">Ending an Deployment</div>
            <p>
              To End a deployment, double click on the deployment you wish to end, and click on "End Deployment".
            </p>
          </q-card-section>
        </q-card> -->
          <!-- Device Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Devices
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="deviceCreation" style="display: inline-block" class="text-h6">Creating a Device</div>
            <p>
              To create a Device, use the Device interface. You will need to know the application the device is a part of. If the device has a parent then you will need to know the parent device's ID aswell.
            </p>
            <div id="deviceCreationMultiple" style="display: inline-block" class="text-h6">Creating Multiple Devices with a CSV</div>
            <p>
              To create multiple devices with a CSV, you will need to use these fields below, then upload the csv through the Device Interface.
              <ul>
                <li>applications_id (INT) * Required</li>
                <li>pcb_id (String)</li>
                <li>version (String)</li>
                <li>sim (String)</li>
                <li>comment (String)</li>
                <li>parentKey (String)</li>
                <li>isHub (INT, 1 for True, 0 for False) </li>
              </ul>
            </p>
            <div  style="display: inline-block" class="text-h6" id="deviceManagement">Managing the Device</div>
            <p>
              To manage a device you double click on the row. This will bring up a menu of options.
              In this menu you will be able to edit certain information for the Device. This information does not need to be stored on the device.
            </p>
            <div id="deviceKeyRegen" style="display: inline-block" class="text-h6">Regenerating the Device Key</div>
            <p>
              To regenerate the device key you are going to need to double
              click the row of the device. Once in the menu, you should see a button "Re-generate Key". Clicking on this
              will generate a new Key for the device. After this, you must update the Key manually on your device, as the old
              Key will be invalid.
            </p>
            <div  style="display: inline-block" class="text-h6" id="deviceComSpec">ID and K</div>
            <p>
              On device creation you will be given a device_id which you will add into the device as ID, this has to be sent with every request to the API.
              You will also be given k, which is the Device Key that was generated for your device, this will also need to be sent with every request to the API.
            </p>
            <div  style="display: inline-block" class="text-h6">Endpoint to create event</div>
            <p>
              <span v-if="currentUserData.role == 'superAdmin'">
                <span style="font-weight: 700">Dev Site URL:</span> <pre>https://Waves App-api.simplesoft.co.nz/events</pre>
              </span>
              <br />
              <span style="font-weight: 700">
                <span v-if="currentUserData.role == 'superAdmin'">Live Site</span> URL:
              </span> <pre>https://api.Waves App.com/events</pre>
              <br />
              <span style="font-weight: 700">Method:</span> POST
              <br />Data is to be sent through as JSON in the Body
            </p>
            <div  style="display: inline-block" class="text-h6">Data Format to be sent to API</div>
            <p>
              The data to be sent to the API must be sent in JSON. All fields that are sent through, that are not part of the JSON demonstration below
              will be added to an Extended Data Field. The required fields are id, type.
            </p>
            <vue-json-pretty :data="eventDataFormat" :highlightMouseoverNode="true" :showLength="true"></vue-json-pretty>
            <p>The Response from the server if successful</p>
            <vue-json-pretty
              :data="{'Result': 'Success', 'events_id': '1111'}"
              :highlightMouseoverNode="true"
              :showLength="true"
            ></vue-json-pretty>
          </q-card-section>
        </q-card> -->
          <!-- Event Specs -->
          <!-- <q-card class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Event Specs
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div  style="display: inline-block" class="text-h6" id="eventDataWebsite">Event data (Via Website)</div>
            <p>
              To view event data via the website, you need to click on either "All Events" or "Trigger Events".
              <br />All events will have a table with all of the events in the current Date range which is set in the toolbar.
              <br />Trigger events will have the files that were sent through with the events that have their status set to "trigger".
            </p>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventDataAPI">Event data (Via API)</div>
              <p>
                This is currently only available for Super Admins. To access the event data via the API, you must have your API Key, and the App ID.
                <br />The Api Key is a randomly generated GUID that identifies a User, So this must be kept Secret. At this time API Keys are Generated manually
                by the Developers, but a system to have this generated automatically is underway.
                <br />The App ID is the ID of the application in which you are requesting the data for, If your are a Super Admin, this is Bypassed but an App ID
                will still need to be sent through (e.g. 10)
                <br />The API Key and APP ID will both need to be sent through in the headers. The Keys for the Headers are Apikey, Appid.
                <br />You also need to send through a date range as parameters on the end of the URL. The format for this is as Follows
                <br />
                <br /> <pre>dateRange[]=2020-08-14&dateRange[]=2020-07-15</pre>
                <br />Optionally you can also send through the type as a Parameter e.g. type=trigger.
                <br />
                <br />The URL for the endpoint is The same as creating an Event, but instead using the GET Method
                <br />A full endpoint for trigger events withing a specific Date Range would be
                <br />
                <pre>{{apiUrlSelection ? apiUrl : 'https://api.Waves App.com'}}/events?dateRange[]=2020-08-14&dateRange[]=2020-07-15&type=trigger</pre>
              </p>
            </div>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventImagesFromS3">Event Images</div>
              <p>
                If you have gotten the event data from the API, to be able to get the Images, you will need to request them from S3.
                To do this you will need to need to generate the Url to get these images. The URL is made up of three peices, the S3 bucket,
                event ID and the file extension. The code example should look like this
                <br>
                <pre>https://{bucket}.s3.ap-southeast-2.amazonaws.com/{event.id}-triggerEvent.{event.fileType}</pre>
                <br>
                An example of a functioning URL will look like this
                <pre>https://Waves App-trigger-events.s3.ap-southeast-2.amazonaws.com/27612-triggerEvent.jpg</pre>

              </p>
            </div>
            <div v-if="currentUserData.role == 'superAdmin'">
              <div  style="display: inline-block" class="text-h6" id="eventMetaData">Creating Meta Data for an Event (Via API)</div>
              <p>
                The API Call uses the same concept of Api Key and App ID stated above in Event Data (Via API).
                No Parameters need to be sent with the API Call, All that needs to be sent through is the "id" in the Body data, and what ever
                other data you wish to be put into the Meta Data.
                <br />The data needs to be in JSON format, and sent through in the Body, and the Api Key + App ID needs to also be sent through in the header
                <br />The Endpoint to send the request to is the same as creating an Event, but instead using the PUT Method.
                <br />All Data that is sent through will be put into the Meta Data field for the Event exactly how it is sent through.
                <br />
                <br />An example of what to send through
              </p>
              <vue-json-pretty
               :data="eventMetaDataFormat"
               :highlightMouseoverNode="true"
               :showLength="true"
              ></vue-json-pretty>
              <p>An example of a successful response</p>
              <vue-json-pretty
                :data="{'Result': 'Success'}"
                :highlightMouseoverNode="true"
                :showLength="true"
             ></vue-json-pretty>
            </div>
          </q-card-section>
        </q-card> -->
          <!-- Ownership Specs -->
          <!-- <q-card class="q-mb-md" v-if="currentUserData.role == 'superAdmin'">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                  Users
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div id="userCreation" style="display: inline-block" class="text-h6">Creating a User</div>
            <p>
              To create a User, use the Users interface. You will need to know the Users Email and Name.
            </p>
            <div id="userRoles" style="display: inline-block" class="text-h6">Giving User Roles</div>
            <p>
              To give a user roles, you will need to use the Users interface (For Super Admins). If you are not a super admin, you can assign a User to an Org,
              or a Deployment using the Corresponding interface and double clicking on the Org/Deployment you want to add the user too.
            </p>
            <div id="userImpersonation" style="display: inline-block" class="text-h6">Impersonating a User (Super Admins Only)</div>
            <p>
              To impersonate another user, you will need to use the Users Interface. When you open the user to impersonate, click the impersonate User
              button, and this will have the system act asif you are that user.
            </p>
          </q-card-section>
        </q-card> -->
          <!-- AWS Specs -->
          <!-- <q-card v-if="currentUserData.role == 'superAdmin'" class="q-mb-md">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                AWS Specs
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div  style="display: inline-block" class="text-h6" id="awsInstallation">AWS CLI Installation</div>
              <p>
                Aws has their CLI installation process well Documented, To view it
               <a
                 target="_blank"
                 href="https://docs.aws.amazon.com/cli/latest/userguide/cli-chap-install.html"
                >
                click here
                </a>
              </p>
            </q-card-section>
          </q-card> -->
        </div>
      </div>
    </q-page>
  </q-scroll-area>
</template>

<script>
  import { mapGetters } from "vuex";
  import VueJsonPretty from "vue-json-pretty";

  export default {
    components: { VueJsonPretty },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        apiUrl: "settings/apiUrl",
      }),
      itemsAdmin: function () {
        return [];
        // [
        //   {
        //     name: "Applications",
        //     icon: "mdi-application",
        //     admin: true,
        //     selectable: false,
        //     children: [
        //       {
        //         name: "What is an Application",
        //         icon: "mdi-help",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#applicationAbout",
        //       },
        //       {
        //         name: "Application Creation",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#applicationCreation",
        //       },
        //       {
        //         name: "Application Management",
        //         icon: "mdi-cogs",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#applicationManagement",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Organizations",
        //     icon: "mdi-domain",
        //     admin: true,
        //     selectable: false,
        //     children: [
        //       {
        //         name: "What is an Organization",
        //         icon: "mdi-help",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#organizationAbout",
        //       },
        //       {
        //         name: "Organization Creation",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#organizationCreation",
        //       },
        //       {
        //         name: "Organization Management",
        //         icon: "mdi-cogs",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#organizationManagement",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Ownerships",
        //     icon: "mdi-transit-connection",
        //     admin: true,
        //     selectable: false,
        //     children: [
        //       {
        //         name: "What is an Ownership",
        //         icon: "mdi-help",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#ownershipAbout",
        //       },
        //       {
        //         name: "Ownership Creation",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#ownershipCreation",
        //       },
        //       {
        //         name: "Ownership Management",
        //         icon: "mdi-cogs",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#ownershipManagement",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Deployments",
        //     icon: "mdi-map-marker-path",
        //     admin: true,
        //     selectable: false,
        //     children: [
        //       {
        //         name: "What is a Deployment",
        //         icon: "mdi-help",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#deploymentAbout",
        //       },
        //       {
        //         name: "Deployment Creation",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: true,
        //         link: "#deploymentCreation",
        //       },
        //       {
        //         name: "Deployment Management",
        //         icon: "mdi-cogs",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#deploymentManagement",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Devices",
        //     icon: "mdi-cctv",
        //     admin: false,
        //     selectable: false,

        //     children: [
        //       {
        //         name: "Device Creation",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#deviceCreation",
        //       },
        //       {
        //         name: "Device Creation - Multiple",
        //         icon: "mdi-plus",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#deviceCreationMultiple",
        //       },
        //       {
        //         name: "Regenerating a Device's Key",
        //         icon: "mdi-key",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#deviceKeyRegen",
        //       },
        //       {
        //         name: "Device Management",
        //         icon: "mdi-cogs",
        //         handler: (node) => this.handleNodeClick(node),
        //         admin: false,
        //         link: "#deviceManagement",
        //       },
        //       {
        //         name: "Device Communication Spec",
        //         icon: "mdi-wifi",
        //         admin: false,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#deviceComSpec",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Events",
        //     icon: "mdi-calendar-alert",
        //     admin: false,
        //     selectable: false,

        //     children: [
        //       {
        //         name: "Creating an Event (Device)",
        //         icon: "mdi-plus",
        //         admin: false,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#deviceComSpec",
        //       },
        //       {
        //         name: "Viewing Event Data",
        //         icon: "mdi-eye",
        //         admin: false,
        //         selectable: false,
        //         children: [
        //           {
        //             name: "Event data (Via Website)",
        //             icon: "mdi-earth",
        //             admin: false,
        //             handler: (node) => this.handleNodeClick(node),
        //             link: "#eventDataWebsite",
        //           },
        //           {
        //             name: "Event Data (Via API)",
        //             icon: "mdi-api",
        //             admin: true,
        //             handler: (node) => this.handleNodeClick(node),
        //             link: "#eventDataAPI",
        //           },
        //           {
        //             name: "Event Images",
        //             icon: "mdi-image",
        //             admin: true,
        //             handler: (node) => this.handleNodeClick(node),
        //             link: "#eventImagesFromS3",
        //           },
        //         ],
        //       },
        //       {
        //         name: "Creating metaData for an Event (Via API)",
        //         icon: "mdi-update",
        //         admin: true,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#eventMetaData",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Users",
        //     icon: "mdi-account-group",
        //     admin: false,
        //     selectable: false,

        //     children: [
        //       {
        //         name: "Creating a User",
        //         icon: "mdi-plus",
        //         admin: false,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#userCreation",
        //       },
        //       {
        //         name: "Giving User Roles",
        //         icon: "mdi-chevron-triple-up",
        //         admin: false,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#userRoles",
        //       },
        //     ],
        //   },
        //   {
        //     name: "AWS",
        //     icon: "mdi-aws",
        //     admin: true,
        //     selectable: false,

        //     children: [
        //       {
        //         name: "CLI Installation",
        //         icon: "mdi-download",
        //         admin: true,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#awsInstallation",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Backups",
        //     icon: "mdi-cloud-upload",
        //     admin: true,
        //     selectable: false,

        //     children: [
        //       {
        //         name: "CLI Installation",
        //         icon: "mdi-download",
        //         admin: true,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#awsInstallation",
        //       },
        //     ],
        //   },
        // ];
      },
      items: function () {
        return [];
        // [
        //   {
        //     name: "Devices",
        //     icon: "mdi-cctv",
        //     admin: false,
        //     selectable: false,
        //     children: [
        //       {
        //         name: "Device Creation",
        //         icon: "mdi-plus",
        //         admin: false,
        //         handler: (node) => this.handleNodeClick(node),
        //         link: "#deviceCreation",
        //       },
        //       {
        //         name: "Device Management",
        //         icon: "mdi-cogs",
        //         admin: false,
        //         selectable: true,
        //         link: "#deviceManagement",
        //       },
        //       {
        //         name: "Device Communication Spec",
        //         icon: "mdi-wifi",
        //         admin: false,
        //         selectable: true,
        //         link: "#deviceComSpec",
        //       },
        //     ],
        //   },
        //   {
        //     name: "Events",
        //     icon: "mdi-calendar-alert",
        //     selectable: false,

        //     admin: false,
        //     children: [
        //       {
        //         name: "Creating an Event (Device)",
        //         icon: "mdi-plus",
        //         admin: false,
        //         selectable: true,
        //         link: "#deviceComSpec",
        //       },
        //       {
        //         name: "Viewing Event Data",
        //         icon: "mdi-eye",
        //         admin: false,
        //         selectable: false,
        //         children: [
        //           {
        //             name: "Event data (Via Website)",
        //             icon: "mdi-earth",
        //             admin: false,
        //             selectable: true,
        //             link: "#eventDataWebsite",
        //           },
        //         ],
        //       },
        //     ],
        //   },
        // ];
      },
    },
    watch: {},
    data: () => ({
      drawer: null,
      apiUrlSelection: true,
      // Scroll Options
      options: {
        duration: 450,
        offset: 0,
        easing: "easeInOutCubic",
      },
      // Table of Contents
      open: [],
      tree: [],

      selected: null,

      // Devices
      eventDataFormat: {
        id: 1,
        k: "Device Key",
        type: "Trigger",
        sessions: 1,
        triggers: 1,
        version: 1,
        battery: 1.3,
        temp: 12.2,
        message: "String",
        time: "UTC Time Stamp",
        image: "Base64 Encoded file (Doesnt need to be an image)",
        ext: "Extention for file. Default: jpg (Doesnt need to be an image)",
      },
      // Events
      eventMetaDataFormat: {
        id: 1,
        exampleData1: "This is example data",
        exampleData2:
          "Both exampleData1 and exampleData2, will be added into the Meta Data field",
      },
    }),
    mounted() {},
    methods: {
      linkWithGoogle() {
        this.$store.dispatch("auth/linkWithGoogle");
      },
      handleNodeClick(node) {
        location.hash = "";
        location.hash = node.link;
      },
    },
  };
</script>
